export default "<ion-nav [root]=\"rootPage\"></ion-nav>";